export const INTERFACE_LAYOUT = Object.freeze({
  classic: 'classic',
  new: 'new',
});

export const getPreferredHomePath = (user) => (
  user?.interface_layout === INTERFACE_LAYOUT.new ? '/home-new' : '/home'
);
